(() => {
  const body = document.body;
  if (!body || body.dataset.season !== 'autumn') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const key = 'sccs-autumn-entry-shown';
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch (_) {
    // If sessionStorage is unavailable, the visual may replay on navigation.
  }

  const layer = document.createElement('div');
  layer.className = 'sccs-autumn-leaves';
  layer.setAttribute('aria-hidden', 'true');

  const leaves = [
    [5, 27, 125, 520, 8.1, 0.05, '#9A623D'],
    [14, 20, -82, -450, 7.4, 0.55, '#B07A4F'],
    [23, 31, 104, 590, 8.8, 0.18, '#815139'],
    [34, 23, -118, -530, 7.8, 1.05, '#C08A55'],
    [43, 29, 142, 640, 8.9, 0.42, '#8C5B3E'],
    [54, 21, -96, -480, 7.5, 1.45, '#A86F45'],
    [63, 33, 116, 690, 9.0, 0.12, '#76503B'],
    [72, 24, -132, -590, 8.3, 0.88, '#B77A49'],
    [81, 30, 91, 550, 8.0, 1.20, '#93603E'],
    [90, 21, -88, -460, 7.4, 0.34, '#C09162'],
    [96, 27, -146, -630, 8.6, 1.65, '#87543A']
  ];

  leaves.forEach(([x, size, drift, rotate, duration, delay, color]) => {
    const leaf = document.createElement('span');
    leaf.className = 'sccs-autumn-leaf';
    leaf.style.setProperty('--leaf-x', `${x}vw`);
    leaf.style.setProperty('--leaf-size', `${size}px`);
    leaf.style.setProperty('--leaf-drift', `${drift}px`);
    leaf.style.setProperty('--leaf-rotate', `${rotate}deg`);
    leaf.style.setProperty('--leaf-duration', `${duration}s`);
    leaf.style.setProperty('--leaf-delay', `${delay}s`);
    leaf.style.setProperty('--leaf-color', color);
    layer.appendChild(leaf);
  });

  body.appendChild(layer);
  window.setTimeout(() => layer.remove(), 10800);
})();
